module.exports = __webpack_public_path__ + "img/connect.b1e9aaa2.svg";